// ResetPasswordPage SaaS — chỉ wire @cnv/ui/pages/auth/ResetPasswordPage với branding.
// Token đọc từ query `?token=` (link trong email). Host's useAuth() cung cấp
// resetPassword(token, pwd) + verifyResetToken(token).

import ResetPasswordPage from '@cnv/ui/pages/auth/ResetPasswordPage';
import '../i18n-host';

export default function ResetPasswordPageSaas() {
  return (
    <ResetPasswordPage
      logoSrc="/cnvwork.png"
      logoAlt="CNV Work"
      brandName="CNV Work"
      tagline="CRM · OPERATIONS · AI AGENT"
      variant="pink"
      loginHref="/login"
      forgotHref="/forgot-password"
    />
  );
}
